import descriptions from "../../../public/configs/abilities/descriptions.json"
import passiveShipValues from "../../../public/configs/abilities/passive-ship-values.json"
import passiveValues from "../../../public/configs/abilities/passive-values.json"
import shipDescriptions from "../../../public/configs/abilities/ship-descriptions.json"
import shipValues from "../../../public/configs/abilities/ship-values.json"
import values from "../../../public/configs/abilities/values.json"

const UNKNOWN_VALUE = "unknown"

function getValue({
  level,
  abilityName,
  variableName,
  abilityDamage,
  isShip,
}: {
  level: number
  abilityName: string
  variableName: string
  abilityDamage: number
  isShip: boolean
}) {
  if (!abilityName || !variableName) {
    return UNKNOWN_VALUE
  }

  const isPercent = variableName[variableName.length - 1] === "%"
  const slicedVariableName = isPercent ? variableName.slice(0, -1) : variableName

  const abilityType = getAbilityType(abilityName)
  const isPassive = abilityType === "Passive"
  const levelsConfig = isShip ? (isPassive ? passiveShipValues : shipValues) : isPassive ? passiveValues : values
  const abilityLevels = (levelsConfig as { name: string; levels: { [key: string]: number }[] }[]).find(
    v => v.name === abilityName,
  )
  const abilityLevelValues = abilityLevels?.levels[Math.max(0, level - 1)]
  const abilityValue = abilityLevelValues?.[slicedVariableName as keyof typeof abilityLevelValues] as unknown as
    | string
    | number
  if (!abilityValue) {
    return UNKNOWN_VALUE
  }

  if (typeof abilityValue === "string" && abilityValue.includes("..")) {
    return abilityValue.replaceAll("..", "-")
  }
  if (Number.isNaN(Number(abilityValue))) {
    return UNKNOWN_VALUE
  }
  const numericValue = isPercent ? Math.round(Number(abilityValue) * 100) : Number(abilityValue)

  let absoluteDamage = ""
  if (slicedVariableName.slice(-7) === "_damage" && !Number.isNaN(Number(abilityValue))) {
    absoluteDamage = ` (≈${Math.round(Number(abilityValue) * abilityDamage)})`
  }

  return `${numericValue}${isPercent ? "%" : ""}${absoluteDamage}`
}

export function getAbilityDescription({
  level,
  abilityName,
  abilityDamage,
  isShip,
}: {
  level: number
  abilityDamage: number
  abilityName: string
  isShip: boolean
}) {
  const descriptionsConfig = isShip ? shipDescriptions : descriptions
  const abilityNames = Object.keys(descriptionsConfig)

  if (!abilityNames.includes(abilityName)) {
    return ""
  }

  const abilityDescription = descriptionsConfig[abilityName as keyof typeof descriptionsConfig][
    Math.max(0, level - 1)
  ] as string

  return abilityDescription
    .replace(/#([a-z_%]+?)#/g, (_, variableName) => {
      return getValue({ level, abilityName, variableName, abilityDamage, isShip })
    })
    .replace(/(\n)+/g, "\n")
    .split("\n")
}
const ABILITY_TYPES = {
  basic: "Basic",
  special: "Special",
  ultimate: "Ultimate",
  assist_and_counter: "Assist/Counter",
  passive: "Passive",
}

export function getAbilityType(abilityName: string) {
  const result = abilityName.split("__")[0] as keyof typeof ABILITY_TYPES

  return ABILITY_TYPES[result]
}
